module.exports = __webpack_public_path__ + "static/img/jy.ba6c478.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/wz/jy.png
// module id = AVIt
// module chunks = 1